import { render, staticRenderFns } from "./AddBankAccount.vue?vue&type=template&id=b74d3e78&scoped=true&"
import script from "./AddBankAccount.vue?vue&type=script&lang=js&"
export * from "./AddBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddBankAccount.vue?vue&type=style&index=0&id=b74d3e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74d3e78",
  null
  
)

export default component.exports